module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        // tabConfigNavKey: 'dashboard',
        showEditByMySelf: false,

        // tooltipMessageKey: 'dashboard.tooltips.absences.message',
        // titleKey: 'dashboard.elements.title.absence',
        icon: '',
        frameColor: '#666666',

        showTopGranted: true,
    },

    methods: {
        showAdditionalContent(){
            this.$.addClass('showAdditionalContentRight')
        },
        hideAdditionalContent(){
            this.$.removeClass('showAdditionalContentRight')
        },
    },
}